<!--
 * @Author: 仙道
 * @Date: 2022-05-27 11:00:02
 * @LastEditTime: 2022-05-29 13:15:52
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/process/list/handle/create.vue
-->
<template>
  <div>
    <a-card :bordered="false" title="公共信息">
      <a-form-model
        :label-col="{ span: 2 }"
        :model="ruleForm"
        :rules="validatorRules"
        :wrapper-col="{ span:12 }"
        class="ant-advanced-search-form w-1200px"
        ref="ruleForm"
      >
        <a-form-item label="标题">
          <a-input placeholder="请输入标题" v-model="ruleForm.title" />
        </a-form-item>
        <a-form-item label="设备名称">
          <a-radio-group v-model="ruleForm.priority">
            <a-radio value="1">一般</a-radio>
            <a-radio value="2">紧急</a-radio>
            <a-radio value="3">非常紧急</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form-model>
    </a-card>
    <a-card :bordered="false" title="表单信息">
      <div class="w-1200px">
        <template v-for="(tplItem, tplIndex) in processStructureValue.tpls">
          <fm-generate-form
            :data="tplItem.formStructure"
            :disabled="currentNode.readonlyTpls===undefined ||
              currentNode.readonlyTpls===null ||
              currentNode.readonlyTpls.indexOf(tplItem.id)===-1?null:true"
            :key="tplIndex"
            :preview="currentNode.hideTpls===undefined ||
              currentNode.hideTpls===null ||
              currentNode.hideTpls.indexOf(tplItem.id)===-1?false:true"
            :ref="'generateForm-'+tplItem.id"
            :remote="remoteFunc"
            v-show="currentNode.hideTpls===undefined ||
              currentNode.hideTpls===null ||
              currentNode.hideTpls.indexOf(tplItem.id)===-1"
          />
        </template>
      </div>
      <div class="text item" style="text-align: center;margin-top:18px">
        <a-button
          :disabled="submitDisabled"
          :key="index"
          @click="submitAction(item)"
          type="primary"
          v-for="(item, index) in processStructureValue.edges"
          v-show="item.source===processStructureValue.nodes[active].id"
        >{{ item.label }}</a-button>
      </div>
    </a-card>
  </div>
</template>

<script>
  import Vue from 'vue'

  import { mapGetters } from 'vuex'
  import 'form-making/dist/FormMaking.css'
  import {
    GenerateForm
  } from '@/components/VueFormMaking'
  Vue.component(GenerateForm.name, GenerateForm)
  import { httpAction, getAction } from '@/api/manage'

  export default {
    // 工单申请-> 创建工单
    name: 'HandleCreateOrder',
    components: {

    },
    data () {
      return {
        ruleForm: {},
        processStructureValue: {},
        submitDisabled: false,
        active: 0,
        validatorRules: {},
        url: {
          create: '/workorder/work-order/create',
          query: '/workorder/work-order/process-structure'
        },
        remoteFunc: {

          // return new Promise((reslove, reject) => {
          //   reslove([])
          // })
        },
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters(['']),
      processId () {
        return this.$route.query.processId || 0
      }
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      if (!this.processId) {
        this.$message.error('流程Id不能为空！')
        return
      }
      this.getProcessNodeList()
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {

      getProcessNodeList () {
        getAction(this.url.query, {
          processId: this.processId,
          workOrderId: 0
        }).then(response => {
          const processStructureValue = response.result
          processStructureValue.tpls = response.result.tpls.map(it => {
            it.formStructure = JSON.parse(it.formStructure)
            return it
          }) //formStructure = JSON.parse(response.result.tpls.formStructure) || {}
          this.processStructureValue = processStructureValue
          this.currentNode = this.processStructureValue.nodes[0]
        })
      },
      submitAction (item) {
        const that = this
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            that.submitDisabled = true
            var stateMap = {}
            that.ruleForm.processId = that.processId
            that.ruleForm.classifyId = that.processStructureValue.process.classifyId
            stateMap['id'] = item.target
            that.ruleForm.sourceState = that.processStructureValue.nodes[this.active].label
            for (var v of this.processStructureValue.nodes) {
              if (v.id === item.target) {
                if (v.assignType !== undefined) {
                  stateMap['process_method'] = v.assignType
                }
                if (v.assignValue !== undefined) {
                  stateMap['processor'] = Array.from(new Set(v.assignValue))
                }
                stateMap['label'] = v.label
                break
              }
            }
            that.ruleForm.state = [stateMap]

            that.ruleForm.tpls = {
              'formStructure': [],
              'formData': []
            }
            // 绑定流程任务
            that.ruleForm.tasks = that.processStructureValue.process.task === undefined ? [] : this.processStructureValue.process.task
            // 追加节点任务
            if (that.processStructureValue.nodes[this.active].task !== undefined && this.processStructureValue.nodes[this.active].task.length > 0) {
              for (var task of this.processStructureValue.nodes[this.active].task) {
                if (that.ruleForm.tasks.indexOf(task) === -1) {
                  that.ruleForm.tasks.push(task)
                }
              }
            }

            var promiseList = []
            for (var tpl of that.processStructureValue.tpls) {
              tpl.formStructure.id = tpl.id
              that.ruleForm.tpls.formStructure.push(tpl.formStructure)
              //  const d = await that.$refs['generateForm-' + tpl.id][0].getData()

              promiseList.push(that.$refs['generateForm-' + tpl.id][0].getData())
            }
            Promise.all(promiseList).then(values => {
              that.ruleForm.source = that.processStructureValue.nodes[this.active].id
              that.ruleForm.tpls.formData = values
              that.ruleForm.is_exec_task = item.isExecuteTask
              httpAction(that.url.create, that.ruleForm, 'post').then(res => {
                that.submitDisabled = false
                if (res.success) {
                  that.$message.success('已完成工单创建!')
                  that.$router.push({ path: '/process/upcoming' })
                }else{
                  that.$message.warning(res.message)
                }
              }).catch(() => {
                that.submitDisabled = false
              })
            }).catch(() => {
              that.submitDisabled = false
            })
          }
        })
         
      }
    }
  }
</script>

<style lang='scss' scoped>


</style>